import React from "react"
import {Link} from "react-router-dom"
// import "./styles_components/Auth.css"

const Auth = () => {
	return(
		<div className="auth-background">
			<div className="container">
				<h2>
					<Link to="/login">Login</Link> or book a <Link to="/">Tour</Link>
				</h2>
			</div>
		</div>
	)
}

export default Auth